// extracted by mini-css-extract-plugin
module.exports = {"mortgage-template-wrapper":"a10a3f92e9--mortgage-template-wrapper--actNT"};